import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Blocked from './Icons/Blocked';
import Button from '../../Button';
const ArtistBlockedOverlay = (_param)=>{
    var { deviation: { deviationId, author }, deviation, unblockDeviant } = _param, props = _object_without_properties(_param, [
        "deviation",
        "deviation",
        "unblockDeviant"
    ]);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _object_spread({
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement(Blocked, null),
        title: t('deviationview.blocked.artist'),
        text: t('deviationview.blocked.artist.text'),
        button: author && /*#__PURE__*/ React.createElement(Button, {
            view: "b14",
            height: "medium",
            onClick: ()=>author && unblockDeviant(author.userId, deviationId)
        }, t('deviationview.blocked.unblockDeviant'))
    }, props));
};
ArtistBlockedOverlay.displayName = 'ArtistBlockedOverlay';
export default ArtistBlockedOverlay;

//# sourceMappingURL=ArtistBlocked.js.map